import { useState, useEffect } from "react";
import { Container, LangContainer } from "./NavbarElements";
import Dropdown from "../../components/common/Dropdown";
import { useNavigate } from "react-router-dom";
import Login from "../../components/login";
import Deposit from "../../components/deposit";
import Withdraw from "../../components/withdraw";
import Register from "../../components/register";
import {
  selectRegisterModal,
  selectDepositModal,
  selectWithdrawModal,
  selectUserBonos,
} from "../../features/modals/modalsSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  logout,
  selectCurrency,
  selectGameBalance,
  selectId,
  selectLogged,
  selectSaldoBonos,
  selectToken,
  selectWithdrawBalance,
  setCompletedBono,
  setNewToken,
  setUserBets,
} from "../../features/user/userSlice";
import { API_URL } from "../../const/api";
import axios from "axios";
import BonosModal from "../../components/bonos";
import OlvidoClave from "../../components/olvidoClave";
import { getId } from "../../utils/localStorage";
import PagoEfectivo from "../../components/pagoEfectivo";
import PagoYape from "../../components/pagoYape";
import JumioVerification from "../../components/JumioVerification";
import PagoKushki from "../../components/pagoKushki";
import PagoAlps from "../../components/pagoAlps";

import { setHayNotificaciones } from "../../features/notifications/notificationsSlide";
import NavComp from "./Nav";
import UserMenuMobile from "../../components/userMenuMobile";
import io from "socket.io-client";
import UserResumeProfile2 from "./UserResumeProfile2";
import PayRetailerModal from "../../components/PayRetailerModal";
import NavComp2 from "./NavComp2";
import DateTimeBanner from "../../components/DateTimeBanner";
import { clearLimites, selectLimites } from "../../features/limitaciones/limitacionesSlice";

const Navbar = () => {
  const id_uo = useSelector(selectId);
  const token = useSelector(selectToken);
  const saldo_juego = useSelector(selectGameBalance);
  const saldo_retiro = useSelector(selectWithdrawBalance);
  const saldo_bonos = useSelector(selectSaldoBonos);
  const moneda = useSelector(selectCurrency);
  const registerModal = useSelector(selectRegisterModal);
  const depositModal = useSelector(selectDepositModal);
  const withdrawModal = useSelector(selectWithdrawModal);
  const bonosModal = useSelector(selectUserBonos);
  const isLoged = useSelector(selectLogged);
  const dispatch = useDispatch();
  const [saldoTotal, setSaldoTotal] = useState("");
  const [clicked, setClicked] = useState(false);
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const limites = useSelector(selectLimites);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 0) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  });

  useEffect(() => {
    if (isLoged) {
      setSaldoTotal(
        (parseFloat(saldo_juego) + parseFloat(saldo_retiro)).toFixed(2)
      );
    }
  }, [saldo_juego, saldo_retiro, saldo_bonos]);

  /* TRAER DATOS APUESTA USER */
  useEffect(() => {
    let socket = "";

    if (isLoged) {
      socket = io.connect("https://sock.betsfactory.co", { forceNew: true });
      try {
        socket.on("connect", () => {
          console.log("conectado");
        });

        socket.on("disconnect", () => {
          console.log("desconectado");
        });

        socket.on("messages", async (data) => {
          if (data.text === "update") {
            const resSocket = await axios.post(API_URL + "datosApuestaUser", {
              token,
              id_uo,
              moneda,
            });
            dispatch(setNewToken(resSocket.data.token));
            if (resSocket.data.status === 1) {
              if (resSocket.data.response.estado !== "1") {
                dispatch(logout({}));
                dispatch(clearLimites({}));
                window.location.href = "/";
                //navigate('/');
              } else {
                dispatch(setNewToken(resSocket.data.token));
                dispatch(setUserBets(resSocket.data.response));
              }
            }
          } else if (data.text === "rollover") {
            dispatch(setCompletedBono(true));
          }
        });

        socket.on("join-group", function (data) {
          console.log("connected: " + data);
        });

        (function () {
          socket.emit("conect", { channel: id_uo });
        })();
      } catch (error) {
        console.log("error");
      }
      const loadData = async () => {
        let id = id_uo;
        /* if(await getId()) {
					let {ades, bdes} = await getId();
					dispatch(setCambioMoneda({id_uo: ades, moneda: bdes}));
					id = ades;
				} */
        const res = await axios.post(API_URL + "datosApuestaUser", {
          id_uo: id,
          token,
          moneda,
        });
        if (res.data.status === 1) {
          if (res.data.response.estado !== "1") {
            dispatch(logout({}));
            dispatch(clearLimites({}));
            //navigate('/');
            window.location.href = "/";
          } else {
            dispatch(setNewToken(res.data.token));
            dispatch(setUserBets(res.data.response));
            const checkNotis = await axios.post(API_URL + "loadNotifications", {
              id_uo: id,
              token: token,
            });
            if (checkNotis.data.status === 1) {
              dispatch(setNewToken(checkNotis.data.token));
              let notis = checkNotis.data.response;
              if (notis.filter((item) => !item.readed).length > 0) {
                dispatch(setHayNotificaciones(true));
              } else dispatch(setHayNotificaciones(false));
            } else {
              dispatch(setNewToken(checkNotis.data.token));
            }
          }
        } else {
          dispatch(setNewToken(res.data.token));
        }
      };

      loadData();
    }

    return () => {
      if (socket) {
        socket.off("connect");
        socket.off("disconnect");
      }
    };
  }, [isLoged]);



  return (
    <Container
      className={clicked ? "active" : scrolled || isLoged ? "sticky" : null}
    >
      <DateTimeBanner />

      <div className="wrap">
        {/* <NavComp
          saldoTotal={saldoTotal}
          clicked={clicked}
          setClicked={setClicked}
        /> */}
        <NavComp2
          saldoTotal={saldoTotal}
          clicked={clicked}
          setClicked={setClicked}
        />
        <LangContainer>
          <Dropdown />
        </LangContainer>
      </div>
      {/* {isLoged && <UserResumeProfile />} */}

      {/* START MODALES */}
      {isLoged && <UserMenuMobile />}
      {!isLoged && <Login />}
      {isLoged && bonosModal && <BonosModal />}
      {registerModal && !isLoged && <Register />}
      {depositModal && isLoged && <Deposit />}
      {!isLoged && <OlvidoClave />}
      {isLoged && limites.tiempo_inactivo<=0 && <PagoEfectivo />}
      {isLoged && limites.tiempo_inactivo<=0 && <PagoYape />}
      {isLoged && <JumioVerification />}
      {isLoged && limites.tiempo_inactivo<=0 && <PayRetailerModal />}
      {isLoged && limites.tiempo_inactivo<=0 && <PagoKushki />}
      {isLoged && limites.tiempo_inactivo<=0 && <PagoAlps />}
      {/* END MODALES */}
    </Container>
  );
};

export default Navbar;
